import { render, staticRenderFns } from "./GETpROM.vue?vue&type=template&id=57b43908&"
import script from "./GETpROM.vue?vue&type=script&lang=js&"
export * from "./GETpROM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports